(function () {
    'use strict';

    angular
        .module('app')
        .directive('columnsets', columnsets);

    columnsets.$inject = ['columnSetService', 'columnFactory', '$localStorage', 'loginService'];

    function columnsets(columnSetService, columnFactory, $localStorage, loginService) {
        // Usage:
        //     <columnsets></columnsets>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                sets: '=?',
                columns: '=?',
                updateGrid: '&',
                processing: '=?',
                csGridOptions: "=?",
                columnsGridOptions: "=?"
            },
            templateUrl: "app/gridsettings/templates/columnsets.html"
        };
        return directive;

        function link(scope, element, attrs) {
            
            scope.columnSetsLabel = loginService.resourceStrings["COLUMN_SETS"];
            scope.previewLabel = loginService.resourceStrings["PREVIEW"];

            scope.applyColumnSet = function () {
                var csColumns = [];
                scope.shown = false;
                scope.processing = true;
                columnSetService.columnSetColumns = scope.columns;
                angular.forEach(scope.columns, function (item, key) {
                    csColumns.push({ schemaId: item.schemaId, width: item.width });
                });

                var columnSet = { id: $localStorage.userSettings['columnSetId'], columns: csColumns };
                columnSetService.saveColumnSet(columnSet).then(function () {
                    gridDataService.reloadGrid();
                    scope.processing = false;
                });
                
            }

            scope.cancel = function () {
                scope.shown = false;
            }

        }
    }

})();